module.exports = __webpack_public_path__ + "img/github.49f5d0c8.svg";